import { format } from 'date-fns';

import { ColumnFilter } from "./Filters/ColumnFilter";
import { DropdownFilter } from "./Filters/DropdownFilter";
import { SelectFilter } from "./Filters/SelectFilter";

const COLUMNS = [
  {
    Header: "Checklist Code",
    Footer: "Checklist Code",
    accessor: "id",
    Filter: "",
    disableFilters: true,
    canFilter: false
  },
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
  {
    Header: "Status",
    Footer: "Status",
    accessor: "status",
    Filter: SelectFilter,
    disableSortBy: true
    // disableFilters: true
  },
  {
    Header: "Fiscal Year",
    Footer: "Fiscal Year",
    accessor: "fiscal_year",
    Filter: "",
    Filter: SelectFilter,
    disableSortBy: true
    // disableFilters: true
    // Cell: ({ value }) => { return format(new Date(value, 'dd/MM/yyyy'))} // this isn't working: the date probable isn't ISO formatting or something
  },
  {
    Header: 'Period',
    Footer: "period",
    accessor: "period",
    Filter: SelectFilter,
    disableSortBy: true
  },
  {
    Header: "Creation Date",
    Footer: "Creation Date",
    accessor: "creation_date",
    Filter: "",
    disableFilters: true,
    // sortType: (a, b) => {
    //   return new Date(b.values.lastLogin) - new Date(a.values.lastLogin);
    // }
    // disableSortBy: true
    Cell: ({ value }) => {
      if (value !== "TBD") {
        return format(new Date(value), 'dd/MM/yyyy')
      } else {
        return value
      }
    }
  },
  {
    Header: "Evaluation Date",
    Footer: "Evaluation Date",
    accessor: "evaluation_date",
    Filter: "",
    disableFilters: true,
    // disableSortBy: true
    // Cell: ({ value }) => { return format(new Date(value, 'dd/MM/yyyy'))}
    Cell: ({ value }) => {
      if (value !== "Pending...") {
        return format(new Date(value), 'dd/MM/yyyy')
      } else {
        return value
      }
    }
  },
  {
    Header: "User",
    Footer: "User",
    accessor: "user",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
  {
    Header: "Parent Company",
    Footer: "Parent Company",
    accessor: "parent_company",
    Filter: SelectFilter,
    disableSortBy: true
    // disableFilters: true
  },
  {
    Header: 'Subsidiary',
    Footer: "Subsidiary",
    accessor: "subsidiary",
    Filter: SelectFilter,
    disableSortBy: true
    // disableFilters: true
  },
  {
    Header: "Region",
    Footer: "Region",
    accessor: "region",
    Filter: SelectFilter,
    disableSortBy: true
    // disableFilters: true
  },
  {
    Header: "Company",
    Footer: "Company",
    accessor: "company",
    Filter: SelectFilter,
    disableSortBy: true
    // disableFilters: true
  },
  {
    Header: "Supervised Entity",
    Footer: "Supervised Entity",
    id: "supervised_entity", // required if accessor is a function
    accessor: row => { return row.supervised_entity ? "Yes" : "No"}, // the row element has all the columns. use console.log() to see this
    Filter: SelectFilter,
    disableSortBy: true
    // disableFilters: true
  },
  {
    Header: "Qualitative evaluation only?",
    Footer: "Qualitative evaluation only?",
    id: "qualitative_evaluation_only",
    accessor: row => row.qualitative_evaluation_only ? "Yes" : "No",
    Filter: SelectFilter,
    disableSortBy: true,
    // disableFilters: true
  },
  {
    Header: "Control Function",
    Footer: "Control Function",
    accessor: "control_function",
    Filter: SelectFilter,
    disableSortBy: true
    // disableFilters: true
  },
  {
    Header: "Visible on BI",
    Footer: "Visible on BI",
    // accessor: "visible_on_bi",
    id: "visible_on_bi",
    accessor: row => row.visible_on_bi ? "Yes" : "No",
    Filter: SelectFilter,
    disableSortBy: true,
    // disableFilters: true
  },
];

export default COLUMNS;